module.exports = __webpack_public_path__ + "static/media/map_icon_house_offline.555e79a2.png";